import React, { useState, useEffect, useContext } from 'react';
import '../../css/home/home.css'; // Asegúrate de crear este archivo CSS también
import { AuthContext } from '../../context/AuthContext';
import CardHomeBalance from '../../components/card/CardHomeBalance'
import ButtonHomeTransaction from '../../components/button/ButtonHomeTransaction'
import ButtonHomeWallet from '../../components/button/ButtonHomeWallet'
import CustomTable from '../../components/table/CustomTable';
import { useNavigate } from 'react-router-dom';
import { formatCurrency } from '../../utils/FormatCurrency'
import axios from 'axios';
import moment from 'moment';

import { FaArrowRightLong } from "react-icons/fa6";

import { FaRegClock, FaRegCalendarAlt } from 'react-icons/fa';
import ModalDepositar from '../../components/modal/modalTransaction/ModalDepositar';
import ModalExchange from '../../components/modal/modalTransaction/ModalExchange'
import ModalSend from '../../components/modal/modalTransaction/modalSend'
import ModalReceibe from '../../components/modal/modalTransaction/modalReceibe'
import { FormatMontoPSE } from '../..//utils/Utils'


import { TbTransfer } from "react-icons/tb";
import { IoIosArrowRoundDown } from "react-icons/io";

import COPU from '../../assets/currency/copu.png'
import USD from '../../assets/currency/usd.png'
import USDT from '../../assets/currency/usdt.png'



const Home = () => {

    const { getAuthenticatedHeaders } = useContext(AuthContext);
    const [balanceWalletCop, setBalanceWalletCop] = useState('')
    const [TotalRows, setTotalRows] = useState('')

    const [balanceWalletUsd, setBalanceWalletUsd] = useState('')
    const [balanceTotalCop, setBalanceTotalCop] = useState('')
    const [LoadingTable, setLoadingTable] = useState('')
    const [DataTable, setDataTable] = useState([])
    const [CurrencyCoin, setCurrencyCoin] = useState("COP")

    const [LoadingTableSkeleton, setLoadingTableSkeleton] = useState(true)


    const [userOtp, /* setUserOtp */] = useState(true)

    const navigate = useNavigate();
    const convertUsd = balanceWalletCop * 4356
    const convertCop = balanceWalletCop / 4356

    const [activeDepositar, setActiveDepositar] = useState(false)
    const [LoadingBalance, setLoadingBalance] = useState(true)

    const [activeSend, setActiveSend] = useState(false)
    const [Recibe, setRecibe] = useState(false)

    const [paso, setPaso] = useState(1)


    const [activeExchange, setActiveExchange] = useState(false)




    const WalletBalanceHome = async () => {
        setLoadingBalance(true)
        try {
            const response = await axios.post(`/balance/wallet_home`, {
                headers: await getAuthenticatedHeaders(),
                currency: CurrencyCoin
            });

            const balances = response?.data?.data?.balances;
            const copBalance = balances?.find(item => item.currency_code === "COP")?.balance || "0.00";
            const usdBalance = balances?.find(item => item.currency_code === "USD")?.balance || "0.00";

            setBalanceWalletUsd(usdBalance)
            setBalanceWalletCop(copBalance);
            setBalanceTotalCop(response.data.data.balance_total);

        } catch (error) {
            console.error("Error fetching wallet balance:", error);
        }
        setLoadingBalance(false)

    };
    const MovementsList = async () => {
        setLoadingTable(true)
        try {
            const response = await axios.post(`/api/movements`, {
                headers: await getAuthenticatedHeaders(),
                page: 1,
                currency: ""
            });
            setTotalRows(response.data?.data?.total_items)
            setDataTable(response.data?.data?.items)

        } catch (error) {
            console.error("Error fetching wallet balance:", error);
        }
        setLoadingTable(false)
        setLoadingTableSkeleton(false)

    };
    const MovementsListPage = async (page) => {
        setLoadingTable(true)
        try {
            const response = await axios.post(`/api/movements`, {
                headers: await getAuthenticatedHeaders(),
                page: page,
                currency: ""
            });
            setDataTable(response.data?.data?.items)
            setTotalRows(response.data?.data?.total_items)

        } catch (error) {
            console.error("Error fetching wallet balance:", error);
        }
        setLoadingTable(false)

    };
    const handlePageChange = page => {
        MovementsListPage(page);
    };
    const OpenReceibe = () => {

        setRecibe(true)
    }

    const OpenDepositar = () => {
        setPaso(1)
        setActiveDepositar(true)
    }
    const columns = [

        {
            name: 'Actividad',
            selector: (row) => (
                <div className="flex flex-row ">

                    <div className='flex flex-row ml-2 items-center'>

                        <img src={row.currency_code === "COP" ? COPU : USD} className="w-4 h-4 mr-2" alt="" />
                        <span className="text-gray-400 text-sm">{row.category_text === "Send" ? "-" : "+"} {FormatMontoPSE(row.amount, false, row.currency_code === "COP" ? "," : ".")} </span>
                    </div>
                </div>
            ),
            sortable: true,
        },
        {
            name: 'Usuario',
            selector: (row) => {

                return row.category_text === "Send" ? row.details.to_user_username : row.category_text === "Receive" ? row.details.from_user_username : row.user.email;
            }, sortable: true,
        },
        {
            name: 'Tipo',
            selector: (row) => {
                const categoryMap = {
                    Convert: "Convertiste",
                    Send: "Enviaste",
                    Receive: "Recibiste",
                    Reload: "Recargaste",
                    Dispersion: "Enviaste",
                };
                return categoryMap[row.category_text] || "";
            }, sortable: true,
        },
        {
            name: 'Estado',
            cell: (row) => (
                <div className={`text-xs px-3 py-1 rounded-full font-medium ${row.status_text === 'Approved' ? 'bg-[#BDFFFF] text-black' : row.status_text === "Rejected" ? 'bg-[#e4847f] text-black' : 'bg-[#FAECDC] text-black'}`}>
                    {row.status_text === "Approved" ? "Aprobado" : row.status_text === "Rejected" ? "Rechazado" : "Pendiente"}
                </div>
            ),
            sortable: true,
        },
        {
            name: 'Fecha y hora',
            cell: (row) => (
                <div className="flex items-center gap-2 text-gray-400">
                    <FaRegCalendarAlt size={14} />
                    {moment(row?.created).format("DD/MM/YY")}
                    <FaRegClock size={14} />
                    {moment(row.created).format("hh:mm a")}
                </div>
            ),
            sortable: true,
        },



    ];


    useEffect(() => {
        const DetailUser = JSON.parse(localStorage.getItem('userDetails'));
        if (DetailUser.type_person == 1) {
            navigate("/persona-natural")


        }

        MovementsList()

    }, []);
    useEffect(() => {
        WalletBalanceHome()
    }, [CurrencyCoin])

    return (
        <div className="home ">
            <div className='w-full flex flex-col h-[100vh]  py-10 px-6  gap-2 ' >
                <div className='w-full flex justify-between text-center mb-1' >
                    <div className='flex flex-col justify-end  '  >
                        <h2 className='text-white text-2xl font-bold leading-8 tracking-tighter	' >Resumen</h2>
                    </div>

                    {/* Creacion del flujo del modal DEPOSITAR */}
                    <ModalDepositar
                        MovementsList={MovementsList}
                        pasesito={3}
                        WalletBalanceHome={WalletBalanceHome}
                        balanceWalletCop={balanceWalletCop}
                        balanceWalletUsd={balanceWalletUsd}
                        activeDepositar={activeDepositar}
                        setActiveDepositar={setActiveDepositar}
                    />
                    <ModalExchange
                        MovementsList={MovementsList}

                        WalletBalanceHome={WalletBalanceHome}
                        balanceWalletCop={balanceWalletCop}
                        balanceWalletUsd={balanceWalletUsd}
                        activeExchange={activeExchange}
                        setActiveExchange={setActiveExchange}
                    />
                    <ModalSend
                        MovementsList={MovementsList}
                        pasesito={1}
                        WalletBalanceHome={WalletBalanceHome}
                        balanceWalletCop={balanceWalletCop}
                        balanceWalletUsd={balanceWalletUsd}
                        activeDepositar={activeSend}
                        setActiveDepositar={setActiveSend}
                    />
                    <ModalReceibe
                        pasesito={1}
                        WalletBalanceHome={WalletBalanceHome}
                        balanceWalletCop={balanceWalletCop}
                        balanceWalletUsd={balanceWalletUsd}
                        activeDepositar={Recibe}
                        setActiveDepositar={setRecibe}
                    />


                    <div className='flex flex-row justify-start items-end' style={{ width: '20%' }} >
                        <p className='text-white text-base font-medium leading-5 tracking-tight'>Qué quieres hacer</p>
                    </div>
                </div>
                <div className='flex flex-row w-full  h-auto justify-around gap-2' >
                    <div className='flex flex-row gap-2' style={{ width: '30%' }} >
                        <CardHomeBalance setCurrencyCoin={setCurrencyCoin} loading={LoadingBalance} imgSrc={USD} balanceCurrency={formatCurrency(balanceTotalCop)} />
                    </div>
                    <div className=' flex flex-row gap-2' style={{ width: '50%' }} >
                        <ButtonHomeWallet loading={LoadingBalance} imageSrc={COPU} title={'COP'} balance={formatCurrency(balanceWalletCop)} balanceConvert={formatCurrency(convertCop) + ' USD'} onClick={() => navigate('/wallet', { state: "USD" })} />
                        <ButtonHomeWallet loading={LoadingBalance} imageSrc={USD} title={'USD'} balance={formatCurrency(balanceWalletUsd)} balanceConvert={formatCurrency(convertUsd) + ' COP'} onClick={() => navigate('/wallet', { state: { currency: "USD" } })} />
                        {/*                         {userOtp && <ButtonHomeWallet imageSrc={USDT} title={'USD Digital'} balance={`$ 0.00`} balanceConvert={'$ 0.00 COP'} onClick={() => navigate('/wallet-usdt')} />}*/}                    </div>

                    <div className=' flex flex-row ' style={{ width: '20%' }}>
                        <div className="w-full h-full items-center justify-center  grid grid-cols-2 gap-2">
                            <ButtonHomeTransaction loading={LoadingBalance} Icon={IoIosArrowRoundDown} classNameIcon={'size-8'} title={'Depositar'} onClick={() => OpenDepositar()} />
                            <ButtonHomeTransaction loading={LoadingBalance} Icon={TbTransfer} classNameIcon={'size-7'} title={'Convertir'} onClick={() => setActiveExchange(true)} />
                            <ButtonHomeTransaction loading={LoadingBalance} Icon={IoIosArrowRoundDown} classNameIcon={'size-8 rotate-[220deg] '} onClick={() => setActiveSend(true)} title={'Enviar'} />
                            <ButtonHomeTransaction loading={LoadingBalance} Icon={IoIosArrowRoundDown} classNameIcon={'size-8 rotate-45 '} title={'Recibir'} onClick={() => OpenReceibe()} />
                        </div>
                    </div>

                </div>
                <div className='w-full h-auto  flex items-center '  >
                    <p className=' text-base text-[#8A8A8E]' >
                        Mis movimientos
                    </p>
                </div>


                <CustomTable totalRows={TotalRows} loadingTable={LoadingTableSkeleton} data={DataTable} columns={columns} handlePageChange={handlePageChange} pending={LoadingTable} filterActive={false} downloadActive={false} datos={true} seeMoreActive={true} />

            </div>
        </div >
    );
};

export default Home;
